import { createRouter, createWebHistory } from 'vue-router'
import { runAppNavigationGuards } from '@/app/router/guards'
import { commonRoutes } from '@/router/modules/common'
import { authRoutes } from '@/router/modules/auth'
import { catalogRoutes } from '@/router/modules/catalog'
import { orderRoutes } from '@/router/modules/order'
import { profileRoutes } from '@/router/modules/profile'
import { supplierRoutes } from '@/router/modules/supplier'
import { adminRoutes } from '@/router/modules/admin'
import { procurementRoutes } from '@/modules/post-mvp/procurement/routes'
import { tenderRoutes } from '@/modules/post-mvp/tender/routes'
import { chatRoutes } from '@/modules/post-mvp/chat/routes'
import { approvalRoutes } from '@/modules/post-mvp/approval/routes'

export function createAppRouter() {
  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      ...commonRoutes,
      ...catalogRoutes,
      ...orderRoutes,
      ...authRoutes,
      ...profileRoutes,
      ...supplierRoutes,
      ...adminRoutes,
      ...procurementRoutes,
      ...tenderRoutes,
      ...chatRoutes,
      ...approvalRoutes,
    ],
    scrollBehavior(_to, _from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      return { top: 0 }
    },
  })

  router.beforeEach(async (to, _from, next) => {
    await runAppNavigationGuards(to, next)
  })

  return router
}

export default createAppRouter()
